import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './fetchBaseQuery';

interface JdmPasswordVerifyCodeRequest {
    code: string;
    username: string;
}

interface JdmPasswordVerifyCodeResponse {
    valid: boolean;
    isSyncedWithFf: boolean;
    usernameMatchesFF: boolean;
    expiresAt: Date | null;
}

interface JdmPasswordResetRequest {
    code: string;
    username: string;
    newPassword: string;
}

interface JdmPasswordResetResponse {
    wasSyncedWithFf: boolean;
}

const api = createApi({
    reducerPath: 'jdmPasswordApi',
    baseQuery,
    endpoints: build => ({
        jdmForgotPassword: build.mutation<void, string>({
            query: username => ({
                url: `/password/api/jdm/forgot-password`,
                method: 'POST',
                body: { username },
            }),
        }),
        jdmVerifyCode: build.mutation<JdmPasswordVerifyCodeResponse, JdmPasswordVerifyCodeRequest>({
            query: ({ code, username }) => ({
                url: `/password/api/jdm/verify-code`,
                method: 'POST',
                body: { code, username },
            }),
        }),
        jdmResetPassword: build.mutation<JdmPasswordResetResponse, JdmPasswordResetRequest>({
            query: ({ code, username, newPassword }) => ({
                url: `/password/api/jdm/reset-password`,
                method: 'POST',
                body: { code, username, newPassword },
            }),
        }),
    }),
});

export const { useJdmForgotPasswordMutation, useJdmVerifyCodeMutation, useJdmResetPasswordMutation } = api;
export default api;
